import useAlertQuery from "@/query/alert-query";
import { cn } from "@/utils/cn";

const AlertImage: React.FC<{
  alias: string;
  data: types.WeatherAlert;
  className?: string;
}> = ({ data, alias, className }) => {
  const imgType = data?.[`${alias}_type` as keyof types.WeatherAlert];
  if (
    typeof imgType === "string" &&
    imgType &&
    ["Онц ноцтой", "Анхааруулга"].includes(imgType)
  ) {
    return (
      <div className="absolute -top-[68px] right-0 h-16 w-16 rounded-full p-3 border-2 border-gray-300 bg-gray-400">
        <img
          src={
            imgType === "Онц ноцтой"
              ? "/images/status/onts_notstoi.png"
              : "/images/status/anhaaruulga.png"
          }
          alt={imgType}
          className={className}
        />
      </div>
    );
  }

  return null;
};
const AlertWidget: React.FC<{ type: string }> = ({ type }) => {
  const { data: alertData, isLoading } = useAlertQuery();

  if (!alertData) return null;
  let alias = type;
  switch(type) {
    case "western":
      alias = "west";
      break;
    case "eastern":
      alias = "east";
      break;
    case "ulaanbaatar":
      alias = "ub";
      break;
  }

  const content = alertData?.[`${alias}_content` as keyof typeof alertData];

  if (!content || typeof content != "string" || content.trim() === "")
    return null;

  const getPositionClasses = () => {
    if (type === "ulaanbaatar") return "absolute right-72 bottom-52";
    if (["darkhan", "erdenet"].includes(type))
      return "absolute right-72 bottom-20";
    return "absolute right-10 top-32 max-w-[400px]";
  };

  return (
    <div
      className={cn(
        "bg-black/50 p-10 rounded-2xl z-10 text-white text-2xl max-w-[800px]",
        getPositionClasses()
      )}
    >
      {isLoading && <div>Түр хүлээнэ үү...</div>}
      <div className="relative">
        <AlertImage alias={alias} data={alertData} />
        <p>{content}</p>
      </div>
    </div>
  );
};
export default AlertWidget;
